(function () {
  function initMenu() {
    var drawer = document.querySelector('[data-menu-drawer]');
    var overlay = document.querySelector('[data-menu-overlay]');
    var openButton = document.querySelector('[data-menu-open]');
    var closeButton = document.querySelector('[data-menu-close]');

    if (!drawer || !overlay || drawer.dataset.menuInitialized === 'true') return;
    drawer.dataset.menuInitialized = 'true';

    function setMenu(open) {
      drawer.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    if (openButton) openButton.addEventListener('click', function () { setMenu(true); });
    if (closeButton) closeButton.addEventListener('click', function () { setMenu(false); });
    overlay.addEventListener('click', function () { setMenu(false); });

    Array.prototype.forEach.call(drawer.querySelectorAll('a[href]'), function (link) {
      link.addEventListener('click', function () {
        setMenu(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setMenu(false);
    });
  }

  function getSections(root, selector) {
    var sections = [];
    if (root.matches && root.matches(selector)) sections.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(selector), function (section) {
        sections.push(section);
      });
    }
    return sections;
  }


  function initProductGallery(gallery) {
    if (!gallery || gallery.dataset.galleryInitialized === 'true') return;
    gallery.dataset.galleryInitialized = 'true';

    var mainImage = gallery.querySelector('.product-media-main-image');
    var thumbnails = gallery.querySelectorAll('[data-product-thumbnail]');
    if (!mainImage || !thumbnails.length) return;

    Array.prototype.forEach.call(thumbnails, function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        var nextImage = thumbnail.getAttribute('data-full-image');
        var nextAlt = thumbnail.getAttribute('data-image-alt') || '';
        if (!nextImage) return;

        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = nextImage;
        mainImage.alt = nextAlt;

        Array.prototype.forEach.call(thumbnails, function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');
      });
    });
  }

  function initReferenceUpload(section) {
    if (!section || section.dataset.referenceUploadInitialized === 'true') return;

    var input = section.querySelector('[data-reference-upload]');
    if (!input) return;

    section.dataset.referenceUploadInitialized = 'true';
    var preview = section.querySelector('[data-reference-upload-preview]');
    var previewImage = section.querySelector('[data-reference-upload-preview-image]');
    var openButton = section.querySelector('[data-reference-upload-open]');
    var dialog = section.querySelector('[data-reference-upload-dialog]');
    var dialogImage = section.querySelector('[data-reference-upload-dialog-image]');
    var closeButton = section.querySelector('[data-reference-upload-close]');
    var errorMessage = section.querySelector('[data-reference-upload-error]');
    var objectUrl = '';

    function setUploadError(message) {
      if (!errorMessage) return;
      errorMessage.textContent = message || '';
      errorMessage.hidden = !message;
    }

    function clearPreview() {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = '';
      }
      if (previewImage) previewImage.removeAttribute('src');
      if (dialogImage) dialogImage.removeAttribute('src');
      if (preview) preview.hidden = true;
    }

    function openPreview() {
      if (!objectUrl) return;
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        window.open(objectUrl, '_blank', 'noopener');
      }
    }

    input.addEventListener('change', function () {
      clearPreview();
      setUploadError('');
      var file = input.files && input.files[0];
      if (!file) return;

      if (!file.type || file.type.indexOf('image/') !== 0) {
        input.value = '';
        setUploadError('That file does not appear to be an image. Please choose a photo and try again.');
        return;
      }

      try {
        objectUrl = URL.createObjectURL(file);
      } catch (error) {
        input.value = '';
        setUploadError('We could not preview that photo. Please choose a different image and try again.');
        return;
      }

      if (previewImage) previewImage.src = objectUrl;
      if (dialogImage) dialogImage.src = objectUrl;
      if (preview) preview.hidden = false;
    });

    if (previewImage) {
      previewImage.addEventListener('error', function () {
        setUploadError('We could not preview that photo. Please choose a different image and try again.');
      });
    }

    if (openButton) openButton.addEventListener('click', openPreview);
    if (previewImage) previewImage.addEventListener('click', openPreview);
    if (closeButton) closeButton.addEventListener('click', function () {
      if (dialog && dialog.open) dialog.close();
    });
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  function initProductSection(section) {
    if (section.dataset.productInitialized === 'true') return;
    section.dataset.productInitialized = 'true';

    var variantSelect = section.querySelector('[data-variant-select]');
    var priceTarget = section.querySelector('[data-product-price]');
    var submitButton = section.querySelector('[data-product-submit]');
    var submitText = section.querySelector('[data-product-submit-text]');
    var quantityField = section.querySelector('[name="quantity"]');
    var inventoryMessage = section.querySelector('[data-inventory-limit-message]');
    var addLabel = submitButton ? submitButton.getAttribute('data-add-label') || 'Add to Cart' : 'Add to Cart';
    var inventoryRequestToken = 0;

    function selectedVariantInventory() {
      var source = null;
      if (variantSelect) source = variantSelect.options[variantSelect.selectedIndex];

      return {
        id: Number(source ? source.value : section.getAttribute('data-default-variant-id') || 0),
        available: source ? source.dataset.available !== 'false' : !submitButton || !submitButton.disabled,
        management: source ? source.dataset.inventoryManagement || '' : section.getAttribute('data-inventory-management') || '',
        policy: source ? source.dataset.inventoryPolicy || '' : section.getAttribute('data-inventory-policy') || '',
        quantity: Math.max(0, parseInt(source ? source.dataset.inventoryQuantity || '0' : section.getAttribute('data-inventory-quantity') || '0', 10) || 0)
      };
    }

    function clearInventoryLimit() {
      if (quantityField) {
        quantityField.removeAttribute('max');
        quantityField.disabled = false;
      }
      if (inventoryMessage) {
        inventoryMessage.hidden = true;
        inventoryMessage.textContent = '';
      }
    }

    function applyInventoryLimit(inventory, alreadyInCart) {
      var limited = inventory.management === 'shopify' && inventory.policy === 'deny';
      if (!limited) {
        clearInventoryLimit();
        if (submitButton) submitButton.disabled = !inventory.available;
        if (submitText) submitText.textContent = inventory.available ? addLabel : 'Sold Out';
        return;
      }

      var remaining = Math.max(0, inventory.quantity - Math.max(0, alreadyInCart || 0));
      if (quantityField) {
        quantityField.setAttribute('max', String(remaining));
        quantityField.disabled = remaining === 0;
        var current = Math.max(1, parseInt(quantityField.value || '1', 10) || 1);
        if (remaining > 0 && current > remaining) quantityField.value = String(remaining);
      }

      if (inventoryMessage) {
        inventoryMessage.hidden = false;
        if (remaining === 0 && alreadyInCart > 0) {
          inventoryMessage.textContent = 'All ' + inventory.quantity + ' available ' + (inventory.quantity === 1 ? 'item is' : 'items are') + ' already in your cart.';
        } else if (remaining === 0) {
          inventoryMessage.textContent = 'Sold out.';
        } else {
          inventoryMessage.textContent = 'Only ' + remaining + ' available to add.';
        }
      }

      var canAdd = inventory.available && remaining > 0;
      if (submitButton) submitButton.disabled = !canAdd;
      if (submitText) submitText.textContent = canAdd ? addLabel : (inventory.available && alreadyInCart > 0 ? 'Maximum in cart' : 'Sold Out');
    }

    function refreshInventoryLimit() {
      var inventory = selectedVariantInventory();
      var limited = inventory.management === 'shopify' && inventory.policy === 'deny';
      var token = ++inventoryRequestToken;

      if (!limited || !inventory.id) {
        applyInventoryLimit(inventory, 0);
        return;
      }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to read cart.');
          return response.json();
        })
        .then(function (cart) {
          if (token !== inventoryRequestToken) return;
          var alreadyInCart = 0;
          (cart.items || []).forEach(function (item) {
            if (Number(item.variant_id) === inventory.id) alreadyInCart += Number(item.quantity) || 0;
          });
          applyInventoryLimit(inventory, alreadyInCart);
        })
        .catch(function () {
          if (token !== inventoryRequestToken) return;
          applyInventoryLimit(inventory, 0);
        });
    }

    function updateVariant() {
      var option = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
      if (option && priceTarget && option.dataset.price) priceTarget.textContent = option.dataset.price;
      refreshInventoryLimit();
    }

    if (quantityField) {
      quantityField.addEventListener('input', function () {
        var max = parseInt(quantityField.getAttribute('max') || '', 10);
        var value = parseInt(quantityField.value || '1', 10);
        if (!isNaN(max) && max >= 0 && value > max) quantityField.value = String(max);
        if (value < 1) quantityField.value = '1';
      });
    }

    if (variantSelect) variantSelect.addEventListener('change', updateVariant);
    updateVariant();
  }

  // Capture the actual selected artwork, even when its merchant-facing label is blank.
  function personalizationCardValue(card, input) {
    if (input.value.trim()) return input.value;
    var image = card.querySelector('img');
    var source = image && image.getAttribute('src');
    if (source) {
      var filename = source.split('?')[0].split('/').pop();
      try { filename = decodeURIComponent(filename); } catch (error) { /* Keep the original filename. */ }
      if (filename) return filename;
    }
    return card.getAttribute('data-library-item-id') || card.getAttribute('data-library-type') || 'Selected design';
  }

  function capturePersonalizationOrderDetails(form) {
    // Rebuild on every submission so a changed selection cannot retain old artwork.
    Array.prototype.forEach.call(form.querySelectorAll('[data-order-design-detail]'), function (field) {
      field.remove();
    });
    function addDetail(name, value) {
      if (!value) return;
      var field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'properties[_' + name + ']';
      field.value = value;
      field.setAttribute('data-order-design-detail', '');
      form.appendChild(field);
    }
    Array.prototype.forEach.call(form.querySelectorAll('.personalization-image-card input[type="radio"]:checked:not(:disabled)'), function (input) {
      var card = input.closest('.personalization-image-card');
      input.value = personalizationCardValue(card, input);
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (!match) return;
      var label = match[1];
      addDetail(label + ' design ID', card.getAttribute('data-library-item-id'));
      var image = card.querySelector('img');
      var source = image && image.getAttribute('src');
      if (source) {
        try { source = new URL(source, window.location.href).href; } catch (error) { /* Preserve the source. */ }
        addDetail(label + ' preview image', source);
      }
    });
  }

  function syncPersonalizationLibraries(section) {
    if (!section) return;

    var required = section.getAttribute('data-personalization-required') === 'true';
    var cardTypes = ['font', 'monogram', 'motif', 'border', 'font_motif_layout'];

    function motifAllowedForTarget(sourceCard, target) {
      var pane = target.closest('[data-personalization-pane]');
      var mode = pane ? pane.getAttribute('data-personalization-pane') : '';
      if (mode === 'motif') return sourceCard.getAttribute('data-motif-allow-standalone') !== 'false';
      if (mode === 'font_motif') return sourceCard.getAttribute('data-motif-allow-font') !== 'false';
      return true;
    }

    cardTypes.forEach(function (type) {
      var sourceCards = document.querySelectorAll('[data-personalization-library="' + type + '"] [data-library-card-template]');
      var targets = section.querySelectorAll('[data-personalization-card-target="' + type + '"]');

      Array.prototype.forEach.call(targets, function (target) {
        Array.prototype.forEach.call(target.querySelectorAll('[data-library-generated="true"]'), function (item) {
          item.remove();
        });

        Array.prototype.forEach.call(sourceCards, function (sourceCard) {
          if (type === 'motif' && !motifAllowedForTarget(sourceCard, target)) return;

          var clone = sourceCard.cloneNode(true);
          clone.hidden = false;
          clone.removeAttribute('data-library-card-template');
          clone.setAttribute('data-library-generated', 'true');
          clone.removeAttribute('data-shopify-editor-block');

          var input = clone.querySelector('input[type="radio"]');
          if (input) {
            var pane = target.closest('[data-personalization-pane]');
            input.value = personalizationCardValue(clone, input);
            input.checked = false;
            input.disabled = !!(pane && pane.hidden);
            input.required = !!required;
          }
          target.appendChild(clone);
        });

        var combinationGroup = target.closest('[data-combination-layout-group]');
        if (combinationGroup) {
          combinationGroup.hidden = target.querySelectorAll('.personalization-image-card').length === 0;
        }
      });
    });

    var threadSources = document.querySelectorAll('[data-personalization-library="thread"] [data-thread-library-item]');
    var threadFields = section.querySelectorAll('[data-thread-field]');

    Array.prototype.forEach.call(threadFields, function (field, fieldIndex) {
      var target = field.querySelector('[data-thread-swatch-target]');
      if (!target) return;

      Array.prototype.forEach.call(target.querySelectorAll('[data-library-generated="true"]'), function (item) {
        item.remove();
      });

      var prefix = field.getAttribute('data-thread-prefix') || 'Thread';
      var showNames = field.getAttribute('data-show-swatch-names') === 'true';

      Array.prototype.forEach.call(threadSources, function (source, sourceIndex) {
        var label = source.getAttribute('data-thread-label') || 'Thread color';
        var color = source.getAttribute('data-thread-color') || '#000000';
        var sourceId = source.getAttribute('data-library-item-id') || String(sourceIndex);
        var safeId = (prefix + '-' + fieldIndex + '-' + sourceId).replace(/[^a-zA-Z0-9_-]/g, '-');

        var option = document.createElement('div');
        option.className = 'thread-swatch-option';
        option.setAttribute('data-library-generated', 'true');

        var input = document.createElement('input');
        input.className = 'visually-hidden thread-swatch-input';
        input.type = 'checkbox';
        input.id = safeId;
        input.value = label;
        input.setAttribute('data-personalization-thread-swatch', '');
        input.setAttribute('data-thread-color', color);
        var threadPane = field.closest('[data-personalization-pane]');
        input.disabled = !!(threadPane && threadPane.hidden);

        var labelEl = document.createElement('label');
        labelEl.className = 'thread-swatch-label';
        labelEl.setAttribute('for', safeId);
        labelEl.setAttribute('title', label);

        var colorEl = document.createElement('span');
        colorEl.className = 'thread-swatch-color';
        colorEl.style.background = color;
        labelEl.appendChild(colorEl);

        var nameEl = document.createElement('span');
        nameEl.className = showNames ? 'thread-swatch-name' : 'visually-hidden';
        nameEl.textContent = label;
        labelEl.appendChild(nameEl);

        option.appendChild(input);
        option.appendChild(labelEl);
        target.appendChild(option);
      });

      var emptyNote = field.querySelector('[data-thread-empty-note]');
      if (emptyNote) emptyNote.hidden = target.querySelectorAll('.thread-swatch-option').length > 0;
    });

    // Hide personalization choices when their required library is empty.
    Array.prototype.forEach.call(section.querySelectorAll('[data-personalization-mode-card]'), function (card) {
      var mode = card.getAttribute('data-personalization-mode-card');
      var pane = section.querySelector('[data-personalization-pane="' + mode + '"]');
      var available = true;
      if (pane) {
        if (mode === 'font') available = pane.querySelectorAll('[data-personalization-card-target="font"] .personalization-image-card').length > 0;
        if (mode === 'monogram') available = pane.querySelectorAll('[data-personalization-card-target="monogram"] .personalization-image-card').length > 0;
        if (mode === 'motif') available = pane.querySelectorAll('[data-personalization-card-target="motif"] .personalization-image-card').length > 0;
        if (mode === 'font_motif') available = pane.querySelectorAll('[data-personalization-card-target="font"] .personalization-image-card').length > 0 && pane.querySelectorAll('[data-personalization-card-target="motif"] .personalization-image-card').length > 0;
        if (mode === 'monogram_motif') available = pane.querySelectorAll('[data-personalization-card-target="monogram"] .personalization-image-card').length > 0 && pane.querySelectorAll('[data-personalization-card-target="border"] .personalization-image-card').length > 0;
      }
      card.hidden = !available;
      var modeInput = card.querySelector('[data-personalization-mode]');
      if (modeInput) modeInput.disabled = !available;
    });

    var checkedMode = section.querySelector('[data-personalization-mode]:checked:not(:disabled)');
    if (!checkedMode) {
      var firstAvailable = section.querySelector('[data-personalization-mode]:not(:disabled)');
      if (firstAvailable) firstAvailable.checked = true;
    }
  }

  function initPersonalizationSection(section) {
    if (section.dataset.personalizationInitialized === 'true') return;
    section.dataset.personalizationInitialized = 'true';

    syncPersonalizationLibraries(section);

    var form = section.querySelector('[data-personalization-form]');
    var modeInputs = section.querySelectorAll('[data-personalization-mode]');
    var panes = section.querySelectorAll('[data-personalization-pane]');
    var errorTarget = section.querySelector('[data-personalization-form-error]');
    var variantSelect = section.querySelector('[data-variant-select]');
    var priceTarget = section.querySelector('[data-product-price]');
    var shopCurrency = section.getAttribute('data-shop-currency') || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    // v1.9: predictable initial optional/proof state. Browsers can restore radio/details state on preview reloads.
    var optionalDetails = form ? form.querySelector('.personalization-optional-details') : null;
    if (optionalDetails) optionalDetails.open = true;
    if (form) {
      var proofChoices = form.querySelectorAll('[data-proof-choice]');
      var noProofChoice = form.querySelector('[data-proof-choice][value="No proof"]');
      Array.prototype.forEach.call(proofChoices, function (choice) { choice.checked = false; });
      if (noProofChoice) noProofChoice.checked = true;
    }

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: shopCurrency }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function currentBasePrice() {
      if (variantSelect && variantSelect.options && variantSelect.selectedIndex >= 0) {
        var option = variantSelect.options[variantSelect.selectedIndex];
        if (option && option.getAttribute('data-price-cents')) return Number(option.getAttribute('data-price-cents')) || 0;
      }
      return Number(section.getAttribute('data-base-price')) || 0;
    }

    function getSelectedAddonType() {
      var active = getActiveMode();
      return active ? (active.getAttribute('data-addon-type') || '') : '';
    }

    function parsePriceLabel(label) {
      var cleaned = String(label || '').replace(/[^0-9.,-]/g, '').replace(',', '.');
      var amount = parseFloat(cleaned);
      return isNaN(amount) ? 0 : Math.round(amount * 100);
    }

    function addonConfiguration(type) {
      var prefix = '';
      var label = '';
      if (type === 'font_motif') {
        prefix = 'font-motif';
        label = 'Font & Motif personalization upgrade';
      } else if (type === 'monogram_motif') {
        prefix = 'monogram-motif';
        label = 'Monogram & Border personalization upgrade';
      } else if (type === 'proof') {
        prefix = 'proof';
        label = 'Personalization proof';
      } else {
        return { type: type, variant: '', price: 0, handle: '', label: '' };
      }

      var price = Number(section.getAttribute('data-' + prefix + '-addon-price')) || 0;
      var fallbackLabel = section.getAttribute('data-' + prefix + '-addon-fallback-label') || '';
      if (!price) price = parsePriceLabel(fallbackLabel);

      return {
        type: type,
        prefix: prefix,
        variant: section.getAttribute('data-' + prefix + '-addon-variant') || '',
        price: price,
        handle: section.getAttribute('data-' + prefix + '-addon-handle') || '',
        label: label
      };
    }

    function updateAddonPriceLabel(type, cents) {
      var target = section.querySelector('[data-addon-price-label="' + type + '"]');
      if (target && cents) target.textContent = '+' + formatMoney(cents);
    }

    function saveResolvedAddon(type, variantId, price) {
      var addon = addonConfiguration(type);
      if (!addon.prefix) return;
      section.setAttribute('data-' + addon.prefix + '-addon-variant', String(variantId || ''));
      section.setAttribute('data-' + addon.prefix + '-addon-price', String(price || 0));
      updateAddonPriceLabel(type, Number(price) || 0);
      updateDisplayedPrice();
    }

    var addonRequests = {};
    function resolveAddon(type) {
      var addon = addonConfiguration(type);
      if (addon.variant) return Promise.resolve(addon);
      if (!addon.handle) return Promise.reject(new Error('The ' + (addon.label || 'personalization add-on') + ' is not configured.'));
      if (addonRequests[type]) return addonRequests[type];

      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      addonRequests[type] = fetch(routeRoot + 'products/' + encodeURIComponent(addon.handle) + '.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load the ' + (addon.label || 'personalization add-on') + '.');
          return response.json();
        })
        .then(function (productData) {
          var variants = productData && productData.variants ? productData.variants : [];
          var variant = null;
          for (var i = 0; i < variants.length; i += 1) {
            if (variants[i].available !== false) { variant = variants[i]; break; }
          }
          // For Unlisted add-ons, Shopify can still allow direct cart purchase even when
          // availability isn't reflected in the preview JSON. Let cart/add.js be authoritative.
          if (!variant && variants.length) variant = variants[0];
          if (!variant || !variant.id) throw new Error('The ' + (addon.label || 'personalization add-on') + ' has no purchasable variant.');
          var price = Number(variant.price) || addon.price || 0;
          saveResolvedAddon(type, variant.id, price);
          return addonConfiguration(type);
        })
        .catch(function (error) {
          addonRequests[type] = null;
          throw error;
        });

      return addonRequests[type];
    }

    function updateDisplayedPrice() {
      if (!priceTarget) return;
      var total = currentBasePrice();
      var addon = addonConfiguration(getSelectedAddonType());
      if (addon.type) total += addon.price;
      var proofChoice = form ? form.querySelector('[data-proof-choice][data-proof-fee="true"]:checked') : null;
      if (proofChoice) total += addonConfiguration('proof').price;
      priceTarget.textContent = formatMoney(total);
    }

    function updateThreadField(field) {
      if (!field) return;
      var checkboxes = field.querySelectorAll('[data-personalization-thread-swatch]');
      var hiddenValue = field.querySelector('[data-thread-value]');
      var selectedTarget = field.querySelector('[data-thread-selection]');
      var selected = [];
      var firstEnabled = null;

      Array.prototype.forEach.call(checkboxes, function (checkbox) {
        checkbox.setCustomValidity('');
        if (!checkbox.disabled && !firstEnabled) firstEnabled = checkbox;
        if (!checkbox.disabled && checkbox.checked) selected.push(checkbox.value);
      });

      if (hiddenValue) hiddenValue.value = selected.join(', ');
      if (selectedTarget) selectedTarget.textContent = 'Selected: ' + (selected.length ? selected.join(', ') : 'None');

      var isRequired = field.getAttribute('data-thread-required') === 'true';
      if (isRequired && firstEnabled && selected.length === 0) {
        firstEnabled.setCustomValidity('Please select at least one thread color.');
      }
    }

    function updateAllThreadFields() {
      Array.prototype.forEach.call(section.querySelectorAll('[data-thread-field]'), updateThreadField);
    }

    function setContainerEnabled(container, enabled) {
      if (!container) return;
      Array.prototype.forEach.call(container.querySelectorAll('input, select, textarea'), function (field) {
        field.disabled = !enabled;
      });
    }

    function setSubgroupVisible(group, visible) {
      if (!group) return;
      group.hidden = !visible;
      setContainerEnabled(group, visible);
    }

    function updateCustomMotifColors(controls) {
      if (!controls) return;
      var customRadio = controls.querySelector('[data-motif-custom-choice][value="Provide color override"]');
      var customFields = controls.querySelector('[data-custom-motif-colors]');
      setSubgroupVisible(customFields, !!(customRadio && customRadio.checked));
      if (customFields) updateAllThreadFields();
    }

    function updateMotifColorControls(pane) {
      if (!pane) return;
      var selectedMotif = pane.querySelector('[data-motif-card]:checked');
      var controls = pane.querySelector('[data-motif-color-controls]');
      if (!controls) return;

      if (!selectedMotif) {
        setSubgroupVisible(controls, false);
        return;
      }

      setSubgroupVisible(controls, true);
      var mode = selectedMotif.getAttribute('data-motif-color-mode') || 'as_pictured';
      var asShownOption = controls.querySelector('[data-motif-as-shown-option]');
      var asShownRadio = controls.querySelector('[data-motif-custom-choice][value="Use motif colors as shown"]');
      var customRadio = controls.querySelector('[data-motif-custom-choice][value="Provide color override"]');

      if (mode === 'one_color') {
        if (asShownOption) asShownOption.hidden = true;
        if (customRadio) customRadio.checked = true;
      } else {
        if (asShownOption) asShownOption.hidden = false;
        if (asShownRadio && !asShownRadio.checked && !(customRadio && customRadio.checked)) asShownRadio.checked = true;
      }
      updateCustomMotifColors(controls);
    }

    function updateCustomBorderColors(controls) {
      if (!controls) return;
      var customRadio = controls.querySelector('[data-border-custom-choice][value="Provide color override"]');
      var customFields = controls.querySelector('[data-custom-border-colors]');
      setSubgroupVisible(customFields, !!(customRadio && customRadio.checked));
      if (customFields) updateAllThreadFields();
    }

    function updateBorderColorControls(pane) {
      if (!pane) return;
      var selectedBorder = pane.querySelector('[data-border-card]:checked');
      var controls = pane.querySelector('[data-border-color-controls]');
      if (!controls) return;

      if (!selectedBorder) {
        setSubgroupVisible(controls, false);
        return;
      }

      setSubgroupVisible(controls, true);
      var mode = selectedBorder.getAttribute('data-border-color-mode') || 'as_pictured';
      var asShownOption = controls.querySelector('[data-border-as-shown-option]');
      var asShownRadio = controls.querySelector('[data-border-custom-choice][value="Use border colors as shown"]');
      var customRadio = controls.querySelector('[data-border-custom-choice][value="Provide color override"]');

      if (mode === 'one_color') {
        if (asShownOption) asShownOption.hidden = true;
        if (customRadio) customRadio.checked = true;
      } else {
        if (asShownOption) asShownOption.hidden = false;
        if (asShownRadio && !asShownRadio.checked && !(customRadio && customRadio.checked)) asShownRadio.checked = true;
      }
      updateCustomBorderColors(controls);
    }

    function updateColorInstructions() {
      var group = section.querySelector('[data-color-instructions-group]');
      if (!group) return;
      var field = group.querySelector('textarea');
      var needsInstructions = false;
      Array.prototype.forEach.call(section.querySelectorAll('.personalization-image-card input[type="radio"]:checked:not(:disabled)'), function (input) {
        if (/\b(?:two|2)\s+colou?rs?\b|\b2\s+thread\s+colou?rs?\b/i.test(input.value)) needsInstructions = true;
      });
      Array.prototype.forEach.call(section.querySelectorAll('[data-thread-field]'), function (threadField) {
        if (threadField.querySelectorAll('[data-personalization-thread-swatch]:checked:not(:disabled)').length > 1) needsInstructions = true;
      });
      group.hidden = !needsInstructions;
      field.disabled = !needsInstructions;
      field.required = needsInstructions;
      field.setCustomValidity(needsInstructions && !field.value.trim() ? 'Please explain where each thread color should go.' : '');
    }

    function getActiveMode() {
      return section.querySelector('[data-personalization-mode]:checked:not(:disabled)');
    }

    function updateMode() {
      var active = getActiveMode();
      var mode = active ? active.getAttribute('data-personalization-mode') : '';

      Array.prototype.forEach.call(panes, function (pane) {
        var isActive = pane.getAttribute('data-personalization-pane') === mode;
        pane.hidden = !isActive;
        setContainerEnabled(pane, isActive);
        if (isActive) {
          updateMotifColorControls(pane);
          updateBorderColorControls(pane);
        }
      });
      updateAllThreadFields();
      updateColorInstructions();
      updateDisplayedPrice();
    }

    Array.prototype.forEach.call(modeInputs, function (input) {
      input.addEventListener('change', updateMode);
    });

    section.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches) return;

      if (input.matches('[data-motif-card]')) updateMotifColorControls(input.closest('[data-personalization-pane]'));
      if (input.matches('[data-motif-custom-choice]')) updateCustomMotifColors(input.closest('[data-motif-color-controls]'));
      if (input.matches('[data-border-card]')) updateBorderColorControls(input.closest('[data-personalization-pane]'));
      if (input.matches('[data-border-custom-choice]')) updateCustomBorderColors(input.closest('[data-border-color-controls]'));
      if (input.matches('[data-personalization-thread-swatch]')) updateThreadField(input.closest('[data-thread-field]'));
      if (input.matches('[data-proof-choice]')) updateDisplayedPrice();
      updateColorInstructions();
    });

    section.addEventListener('input', function (event) {
      if (event.target.matches('[data-color-instructions-group] textarea')) updateColorInstructions();
    });

    if (variantSelect) variantSelect.addEventListener('change', updateDisplayedPrice);
    updateMode();

    // Resolve hidden add-ons as soon as possible so the displayed total uses the real product price.
    ['font_motif', 'monogram_motif', 'proof'].forEach(function (type) {
      resolveAddon(type).catch(function () { return null; });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        var addonType = getSelectedAddonType();
        var proofChoice = form.querySelector('[data-proof-choice][data-proof-fee="true"]:checked');
        var needsPaidAddon = addonType === 'font_motif' || addonType === 'monogram_motif';
        var needsProof = !!proofChoice;
        var referenceUploadInput = form.querySelector('[data-reference-upload]');
        var referenceUploadError = section.querySelector('[data-reference-upload-error]');
        var referenceFile = referenceUploadInput && referenceUploadInput.files ? referenceUploadInput.files[0] : null;
        var hasReferenceFile = !!referenceFile;

        function setReferenceUploadError(message) {
          if (!referenceUploadError) return;
          referenceUploadError.textContent = message || '';
          referenceUploadError.hidden = !message;
        }

        updateAllThreadFields();
        updateColorInstructions();
        capturePersonalizationOrderDetails(form);
        setReferenceUploadError('');

        if (referenceFile && (!referenceFile.type || referenceFile.type.indexOf('image/') !== 0)) {
          event.preventDefault();
          setReferenceUploadError('That file does not appear to be an image. Please choose a photo and try again.');
          return;
        }

        if (!form.reportValidity()) {
          event.preventDefault();
          return;
        }

        // Use the normal Shopify product form when there are no paid add-ons and no file upload.
        // File uploads use Ajax here so upload errors can be shown without losing the customer's selections.
        if (!needsPaidAddon && !needsProof && !hasReferenceFile) return;

        event.preventDefault();
        var submitButton = form.querySelector('[data-product-submit]');
        var submitText = form.querySelector('[data-product-submit-text]');
        var originalText = submitText ? submitText.textContent : '';
        var quantityField = form.querySelector('[name="quantity"]');
        var quantity = quantityField ? Math.max(1, parseInt(quantityField.value || '1', 10)) : 1;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var addedMainKey = '';

        if (errorTarget) {
          errorTarget.hidden = true;
          errorTarget.textContent = '';
        }
        if (submitButton) submitButton.disabled = true;
        if (submitText) submitText.textContent = 'Adding…';

        var requiredAddonTypes = [];
        if (needsPaidAddon) requiredAddonTypes.push(addonType);
        if (needsProof) requiredAddonTypes.push('proof');

        Promise.all(requiredAddonTypes.map(resolveAddon))
          .then(function () {
            var mainFormData = new FormData(form);
            // Hidden line properties give the cart a stable way to verify and repair
            // paid personalization services without exposing implementation details.
            var parentToken = 'otter-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
            mainFormData.set('properties[_otter_parent_token]', parentToken);
            if (needsPaidAddon) mainFormData.set('properties[_otter_requires_upgrade]', 'true');
            if (needsProof) mainFormData.set('properties[_otter_requires_proof]', 'true');
            form.dataset.otterPendingParentToken = parentToken;
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              body: mainFormData,
              headers: { 'Accept': 'application/json' },
              credentials: 'same-origin'
            }).catch(function (networkError) {
              if (hasReferenceFile) {
                var uploadNetworkError = new Error('We could not upload your reference photo. Please check your connection and try again.');
                uploadNetworkError.referenceUploadFailure = true;
                throw uploadNetworkError;
              }
              throw networkError;
            });
          })
          .then(function (response) {
            if (!response.ok) {
              return response.json().catch(function () { return {}; }).then(function (data) {
                var message = data.description || data.message || 'Unable to add this item.';
                var responseError = new Error(message);
                if (hasReferenceFile && /upload|file|image|attachment/i.test(message)) {
                  responseError.referenceUploadFailure = true;
                  responseError.message = 'We could not upload that reference photo. Please choose the image again and try once more.';
                }
                throw responseError;
              });
            }
            return response.json();
          })
          .then(function (mainItem) {
            addedMainKey = mainItem && mainItem.key ? mainItem.key : '';
            var addOns = [];

            if ((needsPaidAddon || needsProof) && !addedMainKey) {
              throw new Error('The item was added, but the personalization add-on could not be linked. Please try again.');
            }

            if (needsPaidAddon) {
              var addon = addonConfiguration(addonType);
              if (!addon.variant) throw new Error('The paid personalization upgrade could not be loaded.');
              addOns.push({
                id: Number(addon.variant),
                quantity: quantity,
                parent_line_key: addedMainKey,
                properties: {
                  '_otter_fee_type': addon.label,
                  '_otter_parent_line': addedMainKey,
                  '_otter_parent_token': form.dataset.otterPendingParentToken || ''
                }
              });
            }

            if (needsProof) {
              var proof = addonConfiguration('proof');
              if (!proof.variant) throw new Error('The proof fee could not be loaded.');
              addOns.push({
                id: Number(proof.variant),
                quantity: quantity,
                parent_line_key: addedMainKey,
                properties: {
                  '_otter_fee_type': proof.label,
                  '_otter_parent_line': addedMainKey,
                  '_otter_parent_token': form.dataset.otterPendingParentToken || ''
                }
              });
            }

            if (!addOns.length) return null;

            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: addOns })
            }).then(function (response) {
              if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || data.message || 'The personalization fee could not be added.'); });
              return response.json();
            });
          })
          .then(function () {
            var expectedFees = {};
            if (needsPaidAddon) {
              var paidAddon = addonConfiguration(addonType);
              expectedFees.upgrade = { id: Number(paidAddon.variant), label: paidAddon.label };
            }
            if (needsProof) {
              var proofAddon = addonConfiguration('proof');
              expectedFees.proof = { id: Number(proofAddon.variant), label: proofAddon.label };
            }
            return verifyPersonalizedCartLine(
              addedMainKey,
              form.dataset.otterPendingParentToken || '',
              expectedFees,
              root
            );
          })
          .then(function () {
            window.location.href = root + 'cart';
          })
          .catch(function (error) {
            var rollback = Promise.resolve();
            if (addedMainKey) {
              rollback = rollbackPersonalizedCartLine(
                addedMainKey,
                form.dataset.otterPendingParentToken || '',
                root
              ).catch(function () { return null; });
            }
            rollback.finally(function () {
              if (error && error.referenceUploadFailure) {
                setReferenceUploadError(error.message || 'We could not upload your reference photo. Please try again.');
              }
              if (errorTarget) {
                errorTarget.textContent = error && error.referenceUploadFailure
                  ? 'Your item was not added. Please try the reference photo again.'
                  : (error.message || 'Something went wrong. Please try again.');
                errorTarget.hidden = false;
              }
              if (submitButton) submitButton.disabled = false;
              if (submitText) submitText.textContent = originalText || 'Add to cart';
            });
          });
      });
    }
  }


  function cartItemProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function cartFeeType(item) {
    var properties = cartItemProperties(item);
    var feeLabel = String(properties._otter_fee_type || '').toLowerCase();
    var handle = String(item && item.handle || '').toLowerCase();
    if (handle.indexOf('proof') !== -1 || feeLabel.indexOf('proof') !== -1) return 'proof';
    if (handle.indexOf('personalization-upgrade') !== -1 ||
        feeLabel.indexOf('personalization') !== -1 ||
        feeLabel.indexOf('font & motif') !== -1 ||
        feeLabel.indexOf('name & motif') !== -1 ||
        feeLabel.indexOf('monogram & border') !== -1) return 'upgrade';
    return '';
  }

  function visibleCartItemCount(cart) {
    return (cart && cart.items ? cart.items : []).reduce(function (total, item) {
      var isChildLine = !!(cartNativeParentKey(item) || cartFallbackParentKey(item));
      if (cartFeeType(item) || isChildLine) return total;
      return total + Math.max(0, Number(item.quantity || 0));
    }, 0);
  }

  function updateHeaderCartCount(cart) {
    var badge = document.querySelector('[data-cart-count]');
    var link = document.querySelector('[data-cart-link]');
    if (!badge && !link) return;

    var count = visibleCartItemCount(cart);
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    if (link) {
      link.setAttribute('aria-label', count > 0
        ? 'Cart, ' + count + ' item' + (count === 1 ? '' : 's')
        : 'Cart');
    }
  }

  function refreshHeaderCartCount() {
    var badge = document.querySelector('[data-cart-count]');
    var link = document.querySelector('[data-cart-link]');
    if (!badge && !link) return Promise.resolve();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return fetchCartJson(root).then(function (cart) {
      updateHeaderCartCount(cart);
      return cart;
    }).catch(function () {
      // Keep the server-rendered badge if the cart endpoint is temporarily unavailable.
      return null;
    });
  }

  function cartNativeParentKey(item) {
    var relationship = item && item.parent_relationship;
    if (!relationship) return '';
    return String(relationship.parent_key || (relationship.parent && relationship.parent.key) || '');
  }

  function cartParentToken(item) {
    return String(cartItemProperties(item)._otter_parent_token || '');
  }

  function cartFallbackParentKey(item) {
    return String(cartItemProperties(item)._otter_parent_line || '');
  }

  function cartExpectedFeeTypes(parentItem) {
    var properties = cartItemProperties(parentItem);
    var expected = [];
    var personalization = String(properties.Personalization || '').toLowerCase();
    var upgradeMarker = String(properties._otter_requires_upgrade || '').toLowerCase() === 'true';
    var proofMarker = String(properties._otter_requires_proof || '').toLowerCase() === 'true';
    var paidPersonalization = personalization === 'font & motif' ||
      personalization === 'name & motif' ||
      personalization === 'monogram & border';
    var proofValue = String(properties.Proof || '').toLowerCase();
    var proofSelected = proofValue === 'yes' || proofValue.indexOf('yes,') === 0 || proofValue.indexOf('send a proof') !== -1;

    if (upgradeMarker || paidPersonalization) expected.push('upgrade');
    if (proofMarker || proofSelected) expected.push('proof');
    return expected;
  }

  function fetchCartJson(root) {
    return fetch(root + 'cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('We could not verify your cart.');
      return response.json();
    });
  }

  function postCartQuantityArray(root, updates) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (response.ok) return response.json();
      return response.json().catch(function () { return {}; }).then(function (data) {
        throw new Error(data.description || data.message || 'We could not repair your cart.');
      });
    });
  }

  function feeBelongsToParent(feeItem, parentItem) {
    var nativeKey = cartNativeParentKey(feeItem);
    if (nativeKey && nativeKey === String(parentItem.key || '')) return true;

    var feeToken = cartParentToken(feeItem);
    var parentToken = cartParentToken(parentItem);
    if (feeToken && parentToken && feeToken === parentToken) return true;

    var fallbackKey = cartFallbackParentKey(feeItem);
    return !!(fallbackKey && fallbackKey === String(parentItem.key || ''));
  }

  function findParentForFee(cart, feeItem) {
    var items = cart && cart.items ? cart.items : [];
    var nativeKey = cartNativeParentKey(feeItem);
    var feeToken = cartParentToken(feeItem);
    var fallbackKey = cartFallbackParentKey(feeItem);
    var found = null;

    items.some(function (candidate) {
      if (cartFeeType(candidate)) return false;
      if (nativeKey && String(candidate.key || '') === nativeKey) { found = candidate; return true; }
      if (feeToken && cartParentToken(candidate) === feeToken) { found = candidate; return true; }
      if (fallbackKey && String(candidate.key || '') === fallbackKey) { found = candidate; return true; }
      return false;
    });
    return found;
  }

  function parentFeeItems(cart, parentItem, type) {
    return (cart && cart.items ? cart.items : []).filter(function (item) {
      return cartFeeType(item) === type && feeBelongsToParent(item, parentItem);
    });
  }

  function verifyParentFeesInCart(cart, parentKey, parentToken, expectedFees) {
    var items = cart && cart.items ? cart.items : [];
    var parent = null;
    items.some(function (item) {
      if (cartFeeType(item)) return false;
      if (parentToken && cartParentToken(item) === parentToken) { parent = item; return true; }
      if (parentKey && String(item.key || '') === String(parentKey)) { parent = item; return true; }
      return false;
    });
    if (!parent) return { valid: false, parent: null, missing: Object.keys(expectedFees || {}) };

    var missing = [];
    Object.keys(expectedFees || {}).forEach(function (type) {
      var fees = parentFeeItems(cart, parent, type);
      var matching = fees.filter(function (fee) { return Number(fee.quantity || 0) === Number(parent.quantity || 0); });
      if (matching.length !== 1 || fees.length !== 1) missing.push(type);
    });

    return { valid: missing.length === 0, parent: parent, missing: missing };
  }

  function addFeesForParent(root, parent, parentToken, feeTypes, expectedFees) {
    if (!feeTypes.length) return Promise.resolve(null);
    var items = feeTypes.map(function (type) {
      var spec = expectedFees[type] || {};
      if (!spec.id) throw new Error('A required personalization fee could not be loaded.');
      return {
        id: Number(spec.id),
        quantity: Number(parent.quantity || 1),
        parent_line_key: String(parent.key || ''),
        properties: {
          '_otter_fee_type': spec.label || (type === 'proof' ? 'Personalization proof' : 'Personalization upgrade'),
          '_otter_parent_line': String(parent.key || ''),
          '_otter_parent_token': parentToken || cartParentToken(parent) || ''
        }
      };
    });

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (response.ok) return response.json();
      return response.json().catch(function () { return {}; }).then(function (data) {
        throw new Error(data.description || data.message || 'A required personalization fee could not be added.');
      });
    });
  }

  function normalizeSpecificParentFees(root, cart, parent, expectedFees) {
    var items = cart && cart.items ? cart.items : [];
    var expectedTypes = Object.keys(expectedFees || {});
    var updates = items.map(function (item) { return Number(item.quantity || 0); });
    var changed = false;

    expectedTypes.forEach(function (type) {
      var fees = parentFeeItems(cart, parent, type);
      fees.forEach(function (fee, feeIndex) {
        var index = items.indexOf(fee);
        if (index < 0) return;
        if (feeIndex === 0) {
          if (Number(fee.quantity || 0) !== Number(parent.quantity || 0)) {
            updates[index] = Number(parent.quantity || 0);
            changed = true;
          }
        } else {
          updates[index] = 0;
          changed = true;
        }
      });
    });

    items.forEach(function (item, index) {
      var type = cartFeeType(item);
      if (!type || !feeBelongsToParent(item, parent)) return;
      if (expectedTypes.indexOf(type) === -1) {
        updates[index] = 0;
        changed = true;
      }
    });

    if (!changed) return Promise.resolve(cart);
    return postCartQuantityArray(root, updates).then(function () { return fetchCartJson(root); });
  }

  function verifyPersonalizedCartLine(parentKey, parentToken, expectedFees, root) {
    if (!Object.keys(expectedFees || {}).length) return Promise.resolve();

    function attempt(cart, canRetry) {
      var status = verifyParentFeesInCart(cart, parentKey, parentToken, expectedFees);
      if (!status.parent) throw new Error('The personalized item could not be verified in your cart.');
      if (status.valid) return Promise.resolve();

      return normalizeSpecificParentFees(root, cart, status.parent, expectedFees)
        .then(function (normalizedCart) {
          var normalizedStatus = verifyParentFeesInCart(normalizedCart, parentKey, parentToken, expectedFees);
          var missing = [];
          Object.keys(expectedFees).forEach(function (type) {
            if (parentFeeItems(normalizedCart, normalizedStatus.parent, type).length === 0) missing.push(type);
          });
          if (!missing.length) return normalizedCart;
          return addFeesForParent(root, normalizedStatus.parent, parentToken, missing, expectedFees)
            .then(function () { return fetchCartJson(root); });
        })
        .then(function (repairedCart) {
          var finalStatus = verifyParentFeesInCart(repairedCart, parentKey, parentToken, expectedFees);
          if (finalStatus.valid) return;
          if (canRetry) return attempt(repairedCart, false);
          throw new Error('We could not securely attach the personalization charges. Your item was not added. Please try again.');
        });
    }

    return fetchCartJson(root).then(function (cart) { return attempt(cart, true); });
  }

  function rollbackPersonalizedCartLine(parentKey, parentToken, root) {
    return fetchCartJson(root).then(function (cart) {
      var items = cart && cart.items ? cart.items : [];
      var updates = items.map(function (item) { return Number(item.quantity || 0); });
      var parent = null;

      items.some(function (item) {
        if (cartFeeType(item)) return false;
        if (parentToken && cartParentToken(item) === parentToken) { parent = item; return true; }
        if (parentKey && String(item.key || '') === String(parentKey)) { parent = item; return true; }
        return false;
      });

      items.forEach(function (item, index) {
        if (parent && item === parent) updates[index] = 0;
        if (cartFeeType(item) && parent && feeBelongsToParent(item, parent)) updates[index] = 0;
        if (cartFeeType(item) && parentToken && cartParentToken(item) === parentToken) updates[index] = 0;
      });

      return postCartQuantityArray(root, updates);
    });
  }


  function initCartSection(section) {
    if (!section || section.dataset.cartInitialized === 'true') return;
    var form = section.querySelector('[data-cart-form]');
    if (!form) return;

    section.dataset.cartInitialized = 'true';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var quantityInputs = Array.prototype.slice.call(section.querySelectorAll('[data-cart-quantity]'));
    var childInputs = Array.prototype.slice.call(section.querySelectorAll('[data-cart-child-quantity]'));
    var checkoutButton = section.querySelector('[data-cart-checkout]');
    var photoDialog = section.querySelector('[data-cart-upload-dialog]');
    var photoDialogImage = section.querySelector('[data-cart-upload-dialog-image]');
    var photoDialogClose = section.querySelector('[data-cart-upload-close]');
    var busy = false;
    var dirtyInput = null;
    var cartIntegrityPromise = null;
    var checkoutVerified = false;
    var cartIntegrityFailed = false;
    var globalCartError = section.querySelector('[data-cart-global-error]');
    var cartFeeVariantCache = {};

    function numericValue(input) {
      var value = parseInt(input && input.value ? input.value : '0', 10);
      return isNaN(value) ? 0 : Math.max(0, value);
    }

    function inputsForVariant(variantId) {
      return quantityInputs.filter(function (input) {
        return (input.getAttribute('data-variant-id') || '') === variantId;
      });
    }

    function childrenForParent(parentKey, parentToken) {
      return childInputs.filter(function (input) {
        var childKey = input.getAttribute('data-parent-key') || '';
        var childToken = input.getAttribute('data-parent-token') || '';
        return (parentToken && childToken && childToken === parentToken) || (parentKey && childKey === parentKey);
      });
    }

    function showGlobalCartError(message) {
      if (!globalCartError) return;
      globalCartError.textContent = message || '';
      globalCartError.hidden = !message;
    }

    function resolveCartFeeVariant(type) {
      if (cartFeeVariantCache[type]) return Promise.resolve(cartFeeVariantCache[type]);
      var handles = type === 'proof'
        ? ['otter-thread-proof']
        : ['personalization-upgrade', 'otter-thread-personalization-upgrade'];

      function tryHandle(index) {
        if (index >= handles.length) {
          return Promise.reject(new Error(type === 'proof'
            ? 'The proof fee could not be loaded.'
            : 'The personalization upgrade could not be loaded.'));
        }
        return fetch(root + 'products/' + encodeURIComponent(handles[index]) + '.js', {
          method: 'GET',
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        }).then(function (response) {
          if (!response.ok) return tryHandle(index + 1);
          return response.json();
        }).then(function (product) {
          if (product && product.id) {
            var variants = product.variants || [];
            var variant = null;
            for (var i = 0; i < variants.length; i += 1) {
              if (variants[i].available !== false) { variant = variants[i]; break; }
            }
            if (!variant && variants.length) variant = variants[0];
            if (!variant || !variant.id) return tryHandle(index + 1);
            cartFeeVariantCache[type] = Number(variant.id);
            return cartFeeVariantCache[type];
          }
          return tryHandle(index + 1);
        });
      }

      return tryHandle(0);
    }

    function planExistingCartRepairs(cart) {
      var items = cart && cart.items ? cart.items : [];
      var updates = items.map(function (item) { return Number(item.quantity || 0); });
      var changed = false;
      var parents = items.filter(function (item) { return !cartFeeType(item); });

      // Remove orphan service lines first.
      items.forEach(function (item, index) {
        if (!cartFeeType(item)) return;
        if (!findParentForFee(cart, item)) {
          updates[index] = 0;
          changed = true;
        }
      });

      parents.forEach(function (parent) {
        var expected = cartExpectedFeeTypes(parent);
        ['upgrade', 'proof'].forEach(function (type) {
          var fees = parentFeeItems(cart, parent, type);
          if (expected.indexOf(type) === -1) {
            fees.forEach(function (fee) {
              var index = items.indexOf(fee);
              if (index >= 0 && updates[index] !== 0) { updates[index] = 0; changed = true; }
            });
            return;
          }

          fees.forEach(function (fee, feeIndex) {
            var index = items.indexOf(fee);
            if (index < 0) return;
            if (feeIndex > 0) {
              if (updates[index] !== 0) { updates[index] = 0; changed = true; }
              return;
            }
            if (Number(fee.quantity || 0) !== Number(parent.quantity || 0)) {
              updates[index] = Number(parent.quantity || 0);
              changed = true;
            }
          });
        });
      });

      return { changed: changed, updates: updates };
    }

    function findMissingCartFees(cart) {
      var items = cart && cart.items ? cart.items : [];
      var missing = [];
      items.forEach(function (parent) {
        if (cartFeeType(parent)) return;
        cartExpectedFeeTypes(parent).forEach(function (type) {
          if (!parentFeeItems(cart, parent, type).length) {
            missing.push({ type: type, parent: parent });
          }
        });
      });
      return missing;
    }

    function addMissingCartFees(cart, missing) {
      if (!missing.length) return Promise.resolve(cart);
      var uniqueTypes = [];
      missing.forEach(function (entry) { if (uniqueTypes.indexOf(entry.type) === -1) uniqueTypes.push(entry.type); });

      return Promise.all(uniqueTypes.map(function (type) {
        return resolveCartFeeVariant(type).then(function (variantId) { return { type: type, id: variantId }; });
      })).then(function (resolved) {
        var byType = {};
        resolved.forEach(function (entry) { byType[entry.type] = entry.id; });
        var addItems = missing.map(function (entry) {
          var parent = entry.parent;
          var token = cartParentToken(parent);
          return {
            id: Number(byType[entry.type]),
            quantity: Number(parent.quantity || 1),
            parent_line_key: String(parent.key || ''),
            properties: {
              '_otter_fee_type': entry.type === 'proof' ? 'Personalization proof' : 'Personalization upgrade',
              '_otter_parent_line': String(parent.key || ''),
              '_otter_parent_token': token || ''
            }
          };
        });

        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: addItems })
        }).then(function (response) {
          if (response.ok) return response.json();
          return response.json().catch(function () { return {}; }).then(function (data) {
            throw new Error(data.description || data.message || 'A required personalization charge could not be restored.');
          });
        }).then(function () { return fetchCartJson(root); });
      });
    }

    function repairCartIntegrity() {
      if (cartIntegrityPromise) return cartIntegrityPromise;

      function repairPass(cart, remainingAttempts, alreadyChanged) {
        var plan = planExistingCartRepairs(cart);
        var afterExisting = plan.changed
          ? postCartQuantityArray(root, plan.updates).then(function () { return fetchCartJson(root); })
          : Promise.resolve(cart);

        return afterExisting.then(function (currentCart) {
          var missing = findMissingCartFees(currentCart);
          if (!missing.length) return { cart: currentCart, changed: alreadyChanged || plan.changed };
          return addMissingCartFees(currentCart, missing).then(function (withFees) {
            return { cart: withFees, changed: true };
          });
        }).then(function (result) {
          var finalPlan = planExistingCartRepairs(result.cart);
          var finalMissing = findMissingCartFees(result.cart);
          if (!finalPlan.changed && !finalMissing.length) return result;
          if (remainingAttempts > 0) return repairPass(result.cart, remainingAttempts - 1, true);
          throw new Error('We could not verify all personalization charges in your cart. Please refresh the page and try again.');
        });
      }

      cartIntegrityPromise = fetchCartJson(root)
        .then(function (cart) { return repairPass(cart, 1, false); })
        .finally(function () { cartIntegrityPromise = null; });
      return cartIntegrityPromise;
    }

    function setBusy(state, row) {
      busy = state;
      section.classList.toggle('cart-is-updating', state);
      if (checkoutButton) checkoutButton.disabled = state;
      quantityInputs.forEach(function (input) { input.disabled = state; });
      Array.prototype.forEach.call(section.querySelectorAll('[data-cart-qty-decrease], [data-cart-qty-increase], [data-cart-remove]'), function (control) {
        if ('disabled' in control) control.disabled = state;
        control.setAttribute('aria-disabled', state ? 'true' : 'false');
      });
      Array.prototype.forEach.call(section.querySelectorAll('[data-cart-line]'), function (cartRow) {
        cartRow.classList.toggle('is-updating', !!(state && row && cartRow === row));
      });
    }

    function showRowError(input, message) {
      var row = input ? input.closest('[data-cart-line]') : null;
      var target = row ? row.querySelector('[data-cart-item-error]') : null;
      if (!target) return;
      target.textContent = message || '';
      target.hidden = !message;
    }

    function updateInventoryMessages() {
      quantityInputs.forEach(function (input) {
        if (input.getAttribute('data-inventory-limited') !== 'true') return;

        var variantId = input.getAttribute('data-variant-id') || '';
        var stock = Math.max(0, parseInt(input.getAttribute('data-inventory-stock') || '0', 10) || 0);
        var group = inputsForVariant(variantId);
        var otherQuantity = 0;

        group.forEach(function (otherInput) {
          if (otherInput !== input) otherQuantity += numericValue(otherInput);
        });

        var maxForLine = Math.max(0, stock - otherQuantity);
        input.setAttribute('max', String(maxForLine));

        var row = input.closest('[data-cart-line]');
        var message = row ? row.querySelector('[data-cart-inventory-message]') : null;
        if (message) {
          var totalInCart = otherQuantity + numericValue(input);
          if (totalInCart > stock) {
            message.textContent = 'Only ' + stock + ' available across all matching items in your cart.';
          } else if (group.length > 1) {
            message.textContent = stock + ' available total; ' + totalInCart + ' currently in your cart.';
          } else {
            message.textContent = stock + ' available total';
          }
        }
      });
    }

    function clampQuantity(input, requested) {
      var desired = Math.max(0, parseInt(requested, 10) || 0);
      if (desired === 0) return 0;
      if (input.getAttribute('data-inventory-limited') !== 'true') return Math.max(1, desired);

      var variantId = input.getAttribute('data-variant-id') || '';
      var stock = Math.max(0, parseInt(input.getAttribute('data-inventory-stock') || '0', 10) || 0);
      var otherQuantity = 0;
      inputsForVariant(variantId).forEach(function (otherInput) {
        if (otherInput !== input) otherQuantity += numericValue(otherInput);
      });
      return Math.max(0, Math.min(desired, stock - otherQuantity));
    }

    function postLineChange(lineNumber, quantity) {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line: Number(lineNumber), quantity: Number(quantity) })
      }).then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'We could not update your cart.');
        });
      });
    }

    function updateAttachedAddons(parentInput, quantity) {
      var parentKey = parentInput.getAttribute('data-line-key') || '';
      var parentToken = parentInput.getAttribute('data-parent-token') || '';
      var children = childrenForParent(parentKey, parentToken).slice().sort(function (a, b) {
        return Number(a.getAttribute('data-line-number') || 0) - Number(b.getAttribute('data-line-number') || 0);
      });
      var chain = Promise.resolve();

      children.forEach(function (child) {
        var lineNumber = Number(child.getAttribute('data-line-number') || 0);
        if (!lineNumber) return;
        chain = chain.then(function () {
          return postLineChange(lineNumber, quantity).then(function () {
            child.value = String(quantity);
          });
        });
      });

      return chain;
    }

    function removeFallbackChildren(parentInput) {
      var parentKey = parentInput.getAttribute('data-line-key') || '';
      var parentToken = parentInput.getAttribute('data-parent-token') || '';
      var children = childrenForParent(parentKey, parentToken).filter(function (child) {
        return child.getAttribute('data-native-nested') !== 'true';
      }).sort(function (a, b) {
        return Number(b.getAttribute('data-line-number') || 0) - Number(a.getAttribute('data-line-number') || 0);
      });
      var chain = Promise.resolve();

      children.forEach(function (child) {
        var lineNumber = Number(child.getAttribute('data-line-number') || 0);
        if (!lineNumber) return;
        chain = chain.then(function () { return postLineChange(lineNumber, 0); });
      });
      return chain;
    }

    function persistQuantity(input, requestedQuantity) {
      if (!input || busy) return Promise.resolve();
      var row = input.closest('[data-cart-line]');
      var lineNumber = Number(input.getAttribute('data-line-number') || 0);
      var desired = clampQuantity(input, requestedQuantity);
      if (!lineNumber) return Promise.resolve();

      if (desired > 0 && desired < 1) desired = 1;
      input.value = String(desired);
      updateInventoryMessages();
      showRowError(input, '');
      setBusy(true, row);

      var operation;
      if (desired === 0) {
        operation = removeFallbackChildren(input).then(function () {
          return postLineChange(lineNumber, 0);
        });
      } else {
        // Keep service/add-on quantities aligned with the personalized item before
        // updating the parent. Reloading afterward lets Shopify recalculate every price.
        operation = updateAttachedAddons(input, desired).then(function () {
          return postLineChange(lineNumber, desired);
        });
      }

      return operation.then(function () {
        dirtyInput = null;
        window.location.reload();
      }).catch(function (error) {
        setBusy(false, row);
        showRowError(input, error && error.message ? error.message : 'We could not update your cart. Please try again.');
      });
    }

    quantityInputs.forEach(function (input) {
      var row = input.closest('[data-cart-line]');
      var decrease = row ? row.querySelector('[data-cart-qty-decrease]') : null;
      var increase = row ? row.querySelector('[data-cart-qty-increase]') : null;

      input.addEventListener('input', function () {
        dirtyInput = input;
        var requested = Math.max(1, parseInt(input.value || '1', 10) || 1);
        var clamped = clampQuantity(input, requested);
        input.value = String(Math.max(1, clamped));
        updateInventoryMessages();
      });

      input.addEventListener('change', function () {
        persistQuantity(input, input.value);
      });

      if (decrease) {
        decrease.addEventListener('click', function () {
          var next = Math.max(1, numericValue(input) - 1);
          if (next === numericValue(input)) return;
          persistQuantity(input, next);
        });
      }

      if (increase) {
        increase.addEventListener('click', function () {
          var next = clampQuantity(input, numericValue(input) + 1);
          if (next <= numericValue(input)) return;
          persistQuantity(input, next);
        });
      }
    });

    Array.prototype.forEach.call(section.querySelectorAll('[data-cart-remove]'), function (removeLink) {
      removeLink.addEventListener('click', function (event) {
        if (busy) {
          event.preventDefault();
          return;
        }
        var row = removeLink.closest('[data-cart-line]');
        var input = row ? row.querySelector('[data-cart-quantity]') : null;
        if (!input) return;
        event.preventDefault();
        persistQuantity(input, 0);
      });
    });

    Array.prototype.forEach.call(section.querySelectorAll('[data-cart-upload-open]'), function (button) {
      button.addEventListener('click', function () {
        var src = button.getAttribute('data-upload-src') || '';
        if (!src || !photoDialog || !photoDialogImage) return;
        photoDialogImage.src = src;
        if (typeof photoDialog.showModal === 'function') photoDialog.showModal();
        else photoDialog.setAttribute('open', '');
      });
    });

    if (photoDialogClose && photoDialog) {
      photoDialogClose.addEventListener('click', function () {
        if (typeof photoDialog.close === 'function') photoDialog.close();
        else photoDialog.removeAttribute('open');
      });
      photoDialog.addEventListener('click', function (event) {
        if (event.target !== photoDialog) return;
        if (typeof photoDialog.close === 'function') photoDialog.close();
        else photoDialog.removeAttribute('open');
      });
    }

    form.addEventListener('submit', function (event) {
      if (busy) {
        event.preventDefault();
        return;
      }
      if (dirtyInput) {
        event.preventDefault();
        persistQuantity(dirtyInput, dirtyInput.value);
        return;
      }

      var submitter = event.submitter || null;
      var isCheckout = !submitter || submitter === checkoutButton || submitter.name === 'checkout';
      if (isCheckout && !checkoutVerified) {
        event.preventDefault();
        showGlobalCartError('');
        setBusy(true, null);
        repairCartIntegrity().then(function (result) {
          if (result.changed) {
            window.location.reload();
            return;
          }
          cartIntegrityFailed = false;
          checkoutVerified = true;
          setBusy(false, null);
          if (form.requestSubmit && checkoutButton) form.requestSubmit(checkoutButton);
          else if (checkoutButton) checkoutButton.click();
        }).catch(function (error) {
          setBusy(false, null);
          cartIntegrityFailed = true;
          if (checkoutButton) checkoutButton.disabled = true;
          showGlobalCartError(error && error.message ? error.message : 'We could not verify your personalization charges. Please refresh the page and try again.');
        });
      }
    });

    updateInventoryMessages();

    // Self-heal service fees on every cart load. Checkout remains disabled until
    // Shopify confirms each paid personalization/proof line is present and in sync.
    showGlobalCartError('');
    setBusy(true, null);
    repairCartIntegrity().then(function (result) {
      if (result.changed) {
        window.location.reload();
        return;
      }
      cartIntegrityFailed = false;
      setBusy(false, null);
    }).catch(function (error) {
      setBusy(false, null);
      cartIntegrityFailed = true;
      if (checkoutButton) checkoutButton.disabled = true;
      showGlobalCartError(error && error.message ? error.message : 'We could not verify your personalization charges. Please refresh the page and try again.');
    });
  }

  function initTheme(root) {
    initMenu();
    refreshHeaderCartCount();
    getSections(root, '[data-product-gallery]').forEach(initProductGallery);
    getSections(root, '[data-product-section]').forEach(initProductSection);
    getSections(root, '[data-personalization-section]').forEach(initReferenceUpload);
    getSections(root, '[data-personalization-section]').forEach(initPersonalizationSection);
    getSections(root, '[data-cart-section]').forEach(initCartSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTheme(document);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshHeaderCartCount();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initTheme(event.target);
    getSections(document, '[data-personalization-section]').forEach(syncPersonalizationLibraries);
  });
})();
